import { WaitroseLogoSvg } from "./utils/WaitroseLogoSvg";
import { FREE_CLICK_AND_COLLECT_THRESHOLD } from "@/constants/constants";
import styles from "./ClickAndCollectPreCountdownMessage.module.scss";

type Props = {
  /**
   * A string representing the price of a selcted variant or an object representing the
   * minimum and maximum prices of a variant group where a specific variant has not been selected
   */
  priceOrRange: string | { min: string; max: string };
  /**
   * A string representing the price of the click and collect delivery
   */
  deliveryPrice: string;
  /**
   * A string representing the collect from local time tomorrow
   */
  collectFromLocalTimeTomorrow: string;
  /**
   * A boolean indicating whether delivery and guarantee updates are enabled
   */
  isDeliveryAndGuaranteeUpdatesEnabled: boolean;
};

export const ClickAndCollectPreCountdownMessageUI = ({
  priceOrRange,
  deliveryPrice,
  collectFromLocalTimeTomorrow,
  isDeliveryAndGuaranteeUpdatesEnabled,
}: Props) => {
  let priceSuffix = "";

  if (!isDeliveryAndGuaranteeUpdatesEnabled) {
    if (typeof priceOrRange === "string") {
      if (parseFloat(priceOrRange) >= FREE_CLICK_AND_COLLECT_THRESHOLD) {
        priceSuffix = "for free";
      } else {
        priceSuffix = `for ${deliveryPrice}`;
      }
    } else {
      if (parseFloat(priceOrRange.min) >= FREE_CLICK_AND_COLLECT_THRESHOLD) {
        priceSuffix = "for free";
      } else {
        if (parseFloat(priceOrRange.max) < FREE_CLICK_AND_COLLECT_THRESHOLD) {
          priceSuffix = `for ${deliveryPrice}`;
        }
      }
    }
  }

  return (
    <div
      className={styles.container}
      data-testid="pre-countdown-message"
      data-component="ClickAndCollectPreCountdown"
    >
      <WaitroseLogoSvg />
      <p className={styles.message} data-testid="pre-countdown-message-text">
        Collect from your nearest Waitrose from {collectFromLocalTimeTomorrow}{" "}
        tomorrow {priceSuffix}
      </p>
    </div>
  );
};
